import e from "react";
const o = {
  variant: "tertiary",
  hasBrandColor: !1
}, a = e.createContext(void 0), n = () => {
  const t = e.useContext(a);
  return t === void 0 ? o : t;
};
export {
  a as BaseTabsContext,
  n as useBaseTabs
};
//# sourceMappingURL=index.es5624.js.map
